import { Stack } from 'components/Stack';
import { h } from 'preact';
import { Card } from '../../../../models';
import { FlippingCard } from '../../FlippingCard';
import { CardBack } from '../CardBack';
import { CardFront } from '../CardFront';
import { FlippingCardContainer } from './DoubleCards.styles';

interface DoubleCardsProps {
  cards: Card[];
  shouldFlip: boolean;
}

const DoubleCards: ({ cards, shouldFlip }: DoubleCardsProps) => h.JSX.Element =
  ({ cards, shouldFlip }) => {
    return (
      <Stack gap={16} data-card-container>
        {cards.map((card) =>
          shouldFlip ? (
            <FlippingCard
              card={card.data}
              flippingCardContainer={FlippingCardContainer}
              cardFront={CardFront}
              cardBack={CardBack}
            />
          ) : (
            <CardFront card={card.data} />
          ),
        )}
      </Stack>
    );
  };

export { DoubleCards };
